import React from 'react'
import { Table } from 'reactstrap'
import Moment from 'react-moment'
import SyncResult from '../Shared/SyncResult'

const CompaniesTable = ({ companies, currentPage, pageSize }) => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>User Count</th>
            <th>Billed User Count</th>
            <th>Last Sync Date</th>
            <th>Last Sync Result</th>
          </tr>
        </thead>
        {companies.length === 0 ? (
          <tr>
            <td colSpan="6" style={{ textAlign: 'center', fontSize: '1.25rem' }}>
              No Companies Found
            </td>
          </tr>
        ) : (
          <tbody>
            {companies.slice(currentPage * pageSize, currentPage * pageSize + pageSize).map((company, index) => {
              const isValid = new Date(company.lastSyncDate) > new Date('01/01/2000 00:00')

              return (
                <tr key={index}>
                  <td>{company.companyName}</td>
                  <td>{company.userCount}</td>
                  <td>{company.billedUserCount}</td>
                  <td>
                    {isValid ? (
                      <Moment format="DD/MM/YYYY">{company.lastSyncDate}</Moment>
                    ) : (
                      <span>No Synchronizations</span>
                    )}
                  </td>
                  <td>
                    <SyncResult result={company.lastSyncResult} />
                  </td>
                </tr>
              )
            })}
          </tbody>
        )}
      </Table>
    </div>
  )
}

export default CompaniesTable
